import * as React from 'react';

import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';

import type { IconProps } from '@avodah-inc/types';
import { cn } from '@avodah-inc/ui/utils';

const downloadVariants = tv({
  base: 'text-base-black',
  variants: {
    variant: {
      default: 'text-base-black',
      onDark: 'text-base-white',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

export type DownloadProps = React.SVGAttributes<SVGSVGElement> &
  VariantProps<typeof downloadVariants> &
  IconProps;

export const Download = React.forwardRef<SVGSVGElement, DownloadProps>(
  (
    {
      className,
      variant,
      viewBox = '0 0 40 42',
      width,
      height,
      fill = 'none',
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        width={width}
        height={height}
        viewBox={viewBox}
        fill={fill}
        className={cn(
          downloadVariants({
            variant,
            className,
          }),
        )}
        ref={ref}
        {...props}
      >
        <path
          d="M0.5 12.5C0.5 6.14873 5.64873 1 12 1H28C34.3513 1 39.5 6.14873 39.5 12.5V29.5C39.5 35.8513 34.3513 41 28 41H12C5.64873 41 0.5 35.8513 0.5 29.5V12.5Z"
          fill="white"
        />
        <path
          d="M0.5 12.5C0.5 6.14873 5.64873 1 12 1H28C34.3513 1 39.5 6.14873 39.5 12.5V29.5C39.5 35.8513 34.3513 41 28 41H12C5.64873 41 0.5 35.8513 0.5 29.5V12.5Z"
          stroke="#3B82F6"
        />
        <path
          d="M26.2945 28.7975C26.5224 28.7979 26.7417 28.8847 26.9081 29.0405C27.0745 29.1963 27.1756 29.4094 27.191 29.6368C27.2064 29.8642 27.1349 30.0889 26.991 30.2657C26.8471 30.4425 26.6415 30.558 26.4157 30.5891L26.2945 30.5975H13.7005C13.4725 30.5974 13.253 30.5108 13.0864 30.3551C12.9197 30.1995 12.8184 29.9863 12.8029 29.7588C12.7873 29.5313 12.8587 29.3064 13.0026 29.1295C13.1465 28.9527 13.3522 28.837 13.5781 28.8059L13.7005 28.7975H26.2945ZM20.0053 11.3999C20.2228 11.3999 20.4329 11.4787 20.5968 11.6216C20.7607 11.7646 20.8673 11.962 20.8969 12.1775L20.9053 12.2999L20.9041 24.5315L24.4633 20.9675C24.6156 20.8146 24.8178 20.7215 25.033 20.7052C25.2482 20.6889 25.4621 20.7505 25.6357 20.8787L25.7365 20.9651C25.8892 21.1176 25.9821 21.3198 25.9982 21.535C26.0143 21.7502 25.9525 21.964 25.8241 22.1375L25.7377 22.2383L20.6461 27.3383L20.5621 27.4139L20.4517 27.4847L20.4085 27.5099L20.2993 27.5555L20.1553 27.5915L20.0713 27.6011L19.9993 27.6035C19.9388 27.6034 19.8785 27.5969 19.8193 27.5843L19.7209 27.5567C19.6073 27.5198 19.5024 27.4602 19.4125 27.3815L14.2645 22.2395C14.1031 22.0791 14.0084 21.8635 13.9995 21.6361C13.9906 21.4087 14.0682 21.1864 14.2167 21.0139C14.3651 20.8414 14.5734 20.7316 14.7996 20.7065C15.0258 20.6814 15.2531 20.7429 15.4357 20.8787L15.5365 20.9663L19.1041 24.5267V12.2999C19.1041 12.0612 19.1989 11.8323 19.3677 11.6635C19.5365 11.4947 19.7666 11.3999 20.0053 11.3999Z"
          fill="#3B82F6"
        />
      </svg>
    );
  },
);

Download.displayName = 'Download';
